// The picture beside the sign-in form: a card in flight over a grid, with the kind of events the app shows.
// Decoration only — the figures are made up and hidden from screen readers; the words under it are read.

/** Which app the picture speaks for: the staff console, or the cardholder's own app. */
export type ShowcaseKind = 'console' | 'cardholder';

/** The page's frame for each: the console's form sits on the right, so the two sign-ins are told apart at a glance. */
export const SPLIT = {
  none: 'split',
  cardholder: 'split split-future',
  console: 'split split-future split-console',
} as const;

const COPY = {
  cardholder: {
    cardLabel: 'Your card',
    events: [
      ['Money loaded', '+$100.00'],
      ['Purchase approved', '$12.40'],
      ['Card locked', 'in one tap'],
    ],
    headline: ['Pay, track and control.', 'All in one place.'],
    line: 'See your balance, follow your spending and lock your card the moment you need to.',
  },
} as const;

export function PaymentShowcase({ kind }: { kind: Exclude<ShowcaseKind, 'console'> }) {
  const copy = COPY[kind];
  return (
    <div className="showcase">
      <div className="showcase-art" aria-hidden="true">
        <div className="showcase-grid"></div>
        <div className="showcase-orbit showcase-orbit-a"></div>
        <div className="showcase-orbit showcase-orbit-b"></div>

        <div className="showcase-stage">
          <div className="showcase-card">
            <div className="showcase-card-top">
              <span>{copy.cardLabel}</span>
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path
                  d="M6 8a8.5 8.5 0 0 1 0 8M10 4a13.5 13.5 0 0 1 0 16M14 .5a18.5 18.5 0 0 1 0 23"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <div>
              <div className="showcase-card-number">
                &bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull; 0042
              </div>
              <div className="showcase-card-foot">
                <span>Valid thru 09/29</span>
                <span>Prepaid</span>
              </div>
            </div>
          </div>

          {copy.events.map(([what, value], i) => (
            <div className={`showcase-event showcase-event-${'abc'[i]}`} key={what}>
              <i className="showcase-dot"></i>
              <span>{what}</span>
              <strong>{value}</strong>
            </div>
          ))}
        </div>
      </div>

      <div className="showcase-copy">
        <p className="eyebrow">The future is here</p>
        <h2>
          {copy.headline[0]}
          <br />
          {copy.headline[1]}
        </h2>
        <p>{copy.line}</p>
      </div>
    </div>
  );
}
